import { useFormikContext } from 'formik';
import { DefiniteFormFieldDefinition2 } from './FieldCreator';
import { FormRow } from './FormRow';

export const FormFields: React.FC<{
  fields: DefiniteFormFieldDefinition2<any, any>[];
  disabled?: boolean;
}> = ({ fields, disabled }) => {
  const { values } = useFormikContext();
  return (
    <>
      {fields.map((field, index) => {
        const fieldDef =
          typeof field === 'function' ? field(values, index) : field;
        if (!fieldDef) return null;
        const RowComponent = fieldDef.rowComponent || FormRow;

        return (
          <RowComponent
            key={fieldDef.name}
            {...fieldDef}
            {...fieldDef.rowProps}
            disabled={disabled || fieldDef.disabled}
          />
        );
      })}
    </>
  );
};
